/* =====================================================================
   You Fly LA — footer curtain PEEK FIX for the homepage and the yh- pages (r16, 2026-09-30).

   Companion to assets/yh-home.js initReveal (section 15c, the "Footer reveal" curtain of the homepage and the yh-
   pages). Loaded by layout/theme.liquid with defer only when yh_on is true, just BEFORE yh-home.js, so it is
   listening when initReveal first sets html.yh-reveal. assets/yfla-curtain.js does the same for every other page.

   THE BUG. The header wrapper (#header-group) is transparent around the floating bar, and the stuck footer's top
   sits at viewport height minus footer height (or, when the footer is taller than 90% of the screen, just under the
   stuck header). Whenever that is above the header's bottom at the top of the page (about 136px: most laptops,
   with the compact footer), the footer's top strip showed through the header's gaps at the top of the page.

   THE FIX. While the end of <main> is more than one viewport below the viewport bottom, html.yh-reveal--far clips
   the footer away completely: clip-path: inset(100% 0 0 0), screen only (the rule is added below; print keeps the
   whole footer). clip-path keeps every footer link focusable and in the accessibility tree (no visibility / display
   change) and moves nothing (CLS 0). The switch is an IntersectionObserver on a 1px sentinel at the end of <main>
   with its root extended one viewport downward, so the footer is back while <main> still covers it (no flash).
   The refresh path re-measures the same thing from geometry whenever initReveal turns the curtain on or off
   (a MutationObserver on html's class, which runs before the next paint) and on resize. A passive scroll check runs
   only while the footer is clipped, so a jump that lands at the footer in one frame un-clips it in that frame.
   A footer link that gets focus while clipped un-clips it at once; initReveal then scrolls it into the open.
   Everything else about the curtain (modes, phone bar off, under-480px off, print, reduced motion) is initReveal's
   and is unchanged.

   WHY A SEPARATE FILE. yh-home.js is about 136 KB; the tool that edits this theme sends a file whole in one
   request, which a file that size does not fit in. This logic can be folded into initReveal the next time
   yh-home.js is edited with the Shopify CLI or the code editor; then drop this file and its script tag.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;

  function init() {
    var foot = d.querySelector('.yh-foot'), footer = foot ? foot.closest('footer') : null, main = d.getElementById('MainContent');
    if (!foot || !footer || !main || window.YH_revealPeek) return;
    var on = false, far = false, io = null, ioRoot;

    if (!d.getElementById('yh-reveal-far')) {
      var st = d.createElement('style');
      st.id = 'yh-reveal-far';
      st.textContent = '@media not print{html.yh-reveal.yh-reveal--far body.yh-home .page-wrapper>footer{clip-path:inset(100% 0 0 0)}}';
      d.head.appendChild(st);
    }
    /* a 1px sentinel on the last line of <main> (position:relative while html.yh-reveal is on), only while the
       curtain is on: base.css grows the last .shopify-section with :last-child, which matters only on a page
       shorter than the screen */
    var mark = d.createElement('div');
    mark.setAttribute('aria-hidden', 'true');
    mark.setAttribute('data-yh-reveal-mark', '');
    mark.style.cssText = 'position:absolute;left:0;bottom:0;width:1px;height:1px;margin:0;padding:0;border:0;pointer-events:none';

    /* same scroll box as initReveal: Horizon's .page-wrapper at 990px and up (base.css), else the document */
    function scroller() {
      var pw = d.querySelector('.page-wrapper');
      return pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 2 ? pw : (d.scrollingElement || root);
    }
    function box() { var sc = scroller(); return (sc === d.scrollingElement || sc === root || sc === d.body) ? null : sc; }
    function setFar(v) {
      far = !!v;
      var want = on && far;
      if (root.classList.contains('yh-reveal--far') !== want) root.classList.toggle('yh-reveal--far', want);
    }
    /* true while the end of <main> is more than one viewport below the bottom of the scroll box */
    function measureFar() {
      var b = box(), bottom = b ? b.getBoundingClientRect().bottom : window.innerHeight, h = b ? b.clientHeight : window.innerHeight;
      return main.getBoundingClientRect().bottom > bottom + h;
    }
    function observe() {
      if (!('IntersectionObserver' in window)) return;
      var b = box();
      if (io && ioRoot === b) return;
      if (io) io.disconnect();
      ioRoot = b;
      io = new IntersectionObserver(function (list) {
        var e = list[list.length - 1], rb = e.rootBounds;
        /* far only when the sentinel is BELOW the extended box; above it (a footer taller than the screen) is near */
        setFar(!e.isIntersecting && (rb ? e.boundingClientRect.top > rb.bottom : measureFar()));
      }, { root: b, rootMargin: '0px 0px 100% 0px' });
      io.observe(mark);
    }
    function sync() {
      on = root.classList.contains('yh-reveal');
      if (on && mark.parentNode !== main) main.appendChild(mark);
      else if (!on && mark.parentNode) mark.parentNode.removeChild(mark);
      if (on) observe();
      setFar(on && measureFar());
    }
    /* initReveal turns html.yh-reveal on and off (load, resize, footer resize, font load): follow it */
    new MutationObserver(function () { if (root.classList.contains('yh-reveal') !== on) sync(); })
      .observe(root, { attributes: true, attributeFilter: ['class'] });
    /* keyboard: un-clip first; initReveal's own focusin handler then scrolls the link into the open */
    footer.addEventListener('focusin', function () { if (on) setFar(false); });
    /* capture: also sees the scroll of .page-wrapper */
    d.addEventListener('scroll', function () { if (on && far && !measureFar()) setFar(false); }, { passive: true, capture: true });
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
    sync();
    window.YH_revealPeek = { sync: sync, far: function () { return on && far; }, version: 'r16' };
  }

  function start() { try { init(); } catch (e) { if (window.console) console.warn('yh-reveal-peek', e); } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
